<template>
  <div v-loading="loading" class="new-stock">
    <div>
      <DocumentInfo
        ref="documentRef"
        :is-detail="true"
        :form-data="formData"
        :ai-audit-type="2"
      ></DocumentInfo>
    </div>
    <div class="product">
      <ProductTable
        ref="productRef"
        :form-data="formData"
        is-detail
      ></ProductTable>
    </div>
    <div class="footer-container">
      <div class="footer-content">
        <span>总计：</span>
        <span class="price">{{
          formattedPrice(formData.price) || '￥0.00'
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import api from '@/modules/projectA/api/order';
import DocumentInfo from './components/DocumentInfo.vue';
import ProductTable from './components/ProductTable.vue';
import { formattedPrice } from '../common/stockOrder';

export default {
  components: { DocumentInfo, ProductTable },
  data() {
    return {
      loading: false,
      formData: {
        price: 0,
        attachList: [],
        planStockVOList: [],
        skuList: [],
        supplierCompanyName: '',
        remark: '',
        lbbm: '',
        categoryId: '',
        aiCheckResult: '',
      },
    };
  },
  computed: {},
  created() {
    this.getDetail();
  },
  methods: {
    formattedPrice,
    async getDetail() {
      this.loading = true;
      try {
        const { id } = this.$route.params;
        const { code, data = {} } = await api.ecStockDetail({ id });
        if (code === '200') {
          this.formData = { ...data };
          this.formData.skuList.forEach((item) => {
            if (!item.hasOwnProperty('price')) {
              this.$set(item, 'price', '');
            }
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.new-stock {
  .product {
    margin-top: 20px;
  }
  .footer-container {
    display: flex;
    margin-top: 20px;
    height: 60px;
    background: #fff;
    .footer-content {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      min-width: 0;
      .price {
        margin: 0 20px 0 10px;
        font-size: 18px;
        color: #f0250f;
        font-weight: 500;
      }
    }
    .footer-btn {
      flex-shrink: 0;
      width: 140px;
      line-height: 60px;
      text-align: center;
      background: #f0250f;
      color: #fff;
      font-size: 16px;
    }
  }
}
</style>
